/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperatoreComuneCompactDTO } from './operatore-comune-compact-dto';
import { PageMetadata } from './page-metadata';


export interface PagedModelOperatoreComuneCompactDTO { 
    content?: Array<OperatoreComuneCompactDTO>;
    page?: PageMetadata;
}

